import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const ProductFaqs = ({ faqs }) => {

  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFaq = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="product-faq-section">
      <div className="container faq-wrapper">

        {/* LEFT */}
        <div className="faq-left">
          {faqs.map((item, i) => {
            const isOpen = activeIndex === i;

            return (
              <div
                className={`faq-item ${isOpen ? "active" : ""}`}
                key={i}
              >
                {/* QUESTION */}
                <div
                  className="faq-question"
                  onClick={() => toggleFaq(i)}
                >
                  <h4 className="card-heading">{item.question}</h4>

                  {/* ROTATING ICON */}
                  <motion.span
                    className="faq-icon"
                    animate={{ rotate: isOpen ? 180 : 0 }}
                    transition={{ duration: 0.3 }}
                  >
                    ▽
                  </motion.span>
                </div>

                {/* ANSWER */}
                <AnimatePresence initial={false}>
                  {isOpen && (
                    <motion.div
  className="faq-answer"
  initial={{ height: 0, opacity: 0 }}
  animate={{ height: "auto", opacity: 1 }}
  exit={{ height: 0, opacity: 0 }}
  transition={{
    height: { duration: 0.4, ease: "easeInOut" },
    opacity: { duration: 0.25 }
  }}
  style={{ overflow: "hidden" }}
>
  <div className="faq-answer-inner">
    <p className="section-text">{item.answer}</p>
  </div>
</motion.div>
                  )}
                </AnimatePresence>

              </div>
            );
          })}
        </div>

        {/* RIGHT */}
        <motion.div
          className="faq-right"
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h3 className="section-subheading">Frequently Asked Questions</h3>
          <h2 className="section-heading">Everything You Need to Know</h2>
          <p className="section-text">
            Find quick answers to common questions about our products, applications, and usage to help you make the right choice with confidence
          </p>
        </motion.div>

      </div>
    </section>
  );
};

export default ProductFaqs;